import styled from '@emotion/styled';
import Link from '../Link';

export const StyledLink = styled(Link)`
  // class rule is required to overwrite ndsc
  &.previous__btn {
    gap: 10px;
    display: flex;
  }
`;
